import React, { useContext } from 'react';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { EntityType } from 'common/types';

export type CampaignModuleContextProps = {
  currency: Currency;
  entityType: Extract<EntityType, 'venue' | 'merchant'>;
  country: Country;
  venues: Venue[];
  merchantId: string;
  timezone: string;
};

export const CampaignModuleContext = React.createContext<CampaignModuleContextProps>({
  currency: 'EUR',
  entityType: 'venue',
  country: 'DEU',
  venues: [],
  merchantId: '',
  timezone: '',
});

export const useCampaignModuleContext = (): CampaignModuleContextProps => {
  const { currency, entityType, country, venues, merchantId, timezone } = useContext(CampaignModuleContext);

  return { currency, entityType, country, venues, merchantId, timezone };
};

export const CampaignModuleContextProvider = CampaignModuleContext.Provider;
